"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveLiquidityRecipe = void 0;
const utils_1 = require("../../utils");
const recipe_1 = require("../recipe");
const cookbook_debug_1 = require("../../utils/cookbook-debug");
class RemoveLiquidityRecipe extends recipe_1.Recipe {
    getExpectedABAmountsFromRecipeOutput(recipeOutput) {
        try {
            if (!recipeOutput) {
                return undefined;
            }
            if (!this.removeLiquidityData) {
                return undefined;
            }
            const { lpERC20Amount, expectedERC20AmountA, expectedERC20AmountB } = this.removeLiquidityData;
            const unshieldStepOutput = recipeOutput.stepOutputs[0];
            const unshieldFee = unshieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, lpERC20Amount);
            });
            if (!unshieldFee) {
                throw new Error('Expected unshield fee to match LP token.');
            }
            const shieldStepOutput = recipeOutput.stepOutputs[recipeOutput.stepOutputs.length - 1];
            const shieldFeeA = shieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, expectedERC20AmountA);
            });
            if (!shieldFeeA) {
                throw new Error('Expected one shield fee to match token A.');
            }
            const shieldFeeB = shieldStepOutput.feeERC20AmountRecipients?.find(fee => {
                return (0, utils_1.compareERC20Info)(fee, expectedERC20AmountB);
            });
            if (!shieldFeeB) {
                throw new Error('Expected one shield fee to match token B.');
            }
            const outputA = shieldStepOutput.outputERC20Amounts.find(outputAmount => {
                return (0, utils_1.compareERC20Info)(outputAmount, expectedERC20AmountA);
            });
            if (!outputA) {
                throw new Error('Expected one output to match token A.');
            }
            const outputB = shieldStepOutput.outputERC20Amounts.find(outputAmount => {
                return (0, utils_1.compareERC20Info)(outputAmount, expectedERC20AmountB);
            });
            if (!outputB) {
                throw new Error('Expected one output to match token B.');
            }
            return {
                lpUnshieldFee: unshieldFee.amount,
                aAmount: outputA.expectedBalance,
                aMinimum: outputA.minBalance,
                bAmount: outputB.expectedBalance,
                bMinimum: outputB.minBalance,
                aShieldFee: shieldFeeA.amount,
                bShieldFee: shieldFeeB.amount,
            };
        }
        catch (err) {
            if (!(err instanceof Error)) {
                throw err;
            }
            cookbook_debug_1.CookbookDebug.error(err);
            return undefined;
        }
    }
}
exports.RemoveLiquidityRecipe = RemoveLiquidityRecipe;
